import styled from 'styled-components';
import StatusTag from '@/components/StatusTag';
import UserInitials from '@/trio-ui/UserInitials';

export const CustomUserInitials = styled(UserInitials)`
  width: 48px;
  height: 48px;
  margin-right: 12px;
`;

export const StatusBadge = styled(StatusTag)`
  display: flex;
  p {
    line-height: 18px;
  }
`;

export const FilterLabelContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FilterLabelCountText = styled.p`
  margin-right: 4px;
  font-weight: 600;
`;
